// extracted by mini-css-extract-plugin
export default {"marginBottom":"marginBottom___apVMc","center":"center___x7_kb","left":"left___g4Qa8","right":"right___K4wi6"};